import GreenCheck from 'assets/icons/check-green.svg';
import { ReactElement } from 'react';

export const TextWithCheckbox = ({
  isValid,
  requirementMessage,
  className,
}: {
  isValid: boolean;
  requirementMessage: string;
  className: string;
}): ReactElement => {
  return (
    <div
      className={`${
        isValid ? 'text-price-green' : 'text-grey'
      } ${className} flex items-center`}>
      <span className="mr-2">{isValid ? <img src={GreenCheck} /> : null}</span>
      {requirementMessage}
    </div>
  );
};
